module.exports = __webpack_public_path__ + "assets/img/llh_c1.36fb1a38.jpg";